import * as React from "react"
import { ThemeCss } from "gatsby-interface"

const nodeCss: ThemeCss = theme => ({
  height: theme.space[3],
  width: theme.space[3],
  borderRadius: theme.radii[5],
  display: `inline-block`,
  transition: `all 1000ms ease`,
})

const listItemCss: ThemeCss = theme => ({
  listStyle: `none`,
  lineHeight: `1`,
  margin: `-${theme.space[3]} 0`,
})

function StepPath({ active = false }) {
  return (
    <li css={listItemCss}>
      <div
        css={theme => ({
          height: theme.space[8],
          width: theme.space[1],
          marginLeft: `0.2rem`,
          transition: `all 800ms ease`,
          background: active ? theme.colors.grey[70] : theme.colors.grey[30],
        })}
      ></div>
    </li>
  )
}

export function Step({ active, text }: { active?: boolean; text: string }) {
  return (
    <li css={listItemCss}>
      <div
        css={theme => [
          nodeCss(theme),
          {
            background: active ? theme.colors.grey[70] : theme.colors.grey[30],
          },
        ]}
      ></div>
      <p
        css={theme => ({
          display: `inline-block`,
          marginLeft: theme.space[4],
          color: active ? theme.colors.grey[70] : theme.colors.grey[30],
          fontSize: theme.fontSizes[1],
        })}
      >
        {text}
      </p>
    </li>
  )
}

export function Stepper({
  currentStep,
  children,
  className,
}: {
  currentStep: number
  children: React.ReactNode
  className?: string
}) {
  const arrayChildren = React.Children.toArray(children)

  return (
    <ul className={className} css={_ => ({ listStyle: `none`, margin: 0 })}>
      {arrayChildren.map((child, idx) => {
        const isFirstItem = idx === 0
        const isActive = idx + 1 <= currentStep

        return (
          <React.Fragment key={idx}>
            {isFirstItem ? null : <StepPath active={isActive} />}
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {React.cloneElement(child as React.ReactElement<any>, {
              active: isActive,
            })}
          </React.Fragment>
        )
      })}
    </ul>
  )
}
